import React from 'react';
import classnames from 'classnames';

// Styles
import './WpContainerBody.scss';

export type Padding = 0 | '025' | '05' | 16 | 24 | 32;
const DEFAULT_PADDING = 16;

export interface Props {
  children?: React.ReactNode;
  className?: string;
  padding?: Padding;
}

const WpContainerBody: React.FC<Props> = ({ children, className, padding = DEFAULT_PADDING }: Props) => {
  const classNamePrefix = 'WpContainerBody';
  const classes = classnames(className, classNamePrefix, `${classNamePrefix}--p-${padding}`);
  return <div className={classes}>{children}</div>;
};

export default WpContainerBody;
